<!--eslint-disable-->
<template>
    <el-dialog :visible.sync="formVisible" @close="closeDialog" @open="openDialog">
        <template slot="title">
            <div class="header-container">
                <span class="main-title">Cadastro de Empresas</span>
            </div>
        </template>
        <el-form :model="form">
            <el-row>
                <el-col :span="12">
                    <div class="fields-container">
                        <el-form-item v-show="isNewCompany" label="" label-width="150px" style="min-height:40px">
                            <el-image :src="getSrc" :alt="form.myTicker">
                                <template slot="error">Envie a logo para o administrador</template>
                            </el-image>
                        </el-form-item>
                        <el-form-item v-show="!isNewCompany" label="" label-width="150px" class="logo-in-form">
                            <el-image :src="getSrc" :alt="form.myTicker" class="bigImage">
                                <template slot="error">Envie a logo para o administrador</template>
                            </el-image>
                        </el-form-item>
                        <el-form-item v-show="isNewCompany" label="Ticker*" label-width="150px">
                            <el-input @blur="validateMyTicker" v-model="form.myTicker" style="width: auto;" :size="inputSize" :class="[isValid.myTicker ? '' : 'input-error']"></el-input>
                        </el-form-item>
                        <el-form-item label="Analista*" label-width="150px">
                            <el-select multiple @change="validateAnalyst" v-model="form.analyst" :size="inputSize" :class="[isValid.analyst ? '' : 'input-error']">
                                <el-option label="BP" value="BP"></el-option>
                                <el-option label="MA" value="MA"></el-option>
                                <el-option label="MM" value="MM"></el-option>
                                <el-option label="PH" value="PH"></el-option>
                                <el-option label="AK" value="AK"></el-option>
                                <el-option label="GB" value="GB"></el-option>
                                <el-option label="PR" value="PR"></el-option>
                                <el-option label="LL" value="LL"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="Setor*" label-width="150px" :class="[isValid.mySector ? '' : 'input-error']">
                            <el-select @change="validateMySector" v-model="form.mySector" :size="inputSize">
                                <el-option label="Pulp & Paper" value="Pulp & Paper"></el-option>
                                <el-option label="Mining & Steel" value="Mining & Steel"></el-option>
                                <el-option label="Consumo" value="Consumo"></el-option>
                                <el-option label="Educação" value="Educação"></el-option>
                                <el-option label="Financials" value="Financials"></el-option>
                                <el-option label="Malls" value="Malls"></el-option>
                                <el-option label="Outros" value="Outros"></el-option>
                                <el-option label="Pharma" value="Pharma"></el-option>
                                <el-option label="Homebuilders" value="Homebuilders"></el-option>
                                <el-option label="Malls" value="Malls"></el-option>
                                <el-option label="Properties" value="Properties"></el-option>
                                <el-option label="Real Estate Brokers" value="Real Estate Brokers"></el-option>
                                <el-option label="Rental" value="Rental"></el-option>
                                <el-option label="TMT" value="TMT"></el-option>
                                <el-option label="Utilities" value="Utilities"></el-option>
                                <el-option label="Varejo" value="Varejo"></el-option>
                                <el-option label="Óleo & Gás" value="Óleo & Gás"></el-option>
                                <el-option label="Healthcare" value="Healthcare"></el-option>
                                <el-option label="Seguradoras" value="Seguradoras"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </el-col>
                <el-col :span="12">
                    <div class="fields-container">
                        <el-form-item v-show="!isNewCompany" label="Ticker*" label-width="150px">
                            <el-input @blur="validateMyTicker" v-model="form.myTicker" style="width: auto;" :size="inputSize" :class="[isValid.myTicker ? '' : 'input-error']"></el-input>
                        </el-form-item>
                        <el-form-item label="CNPJ*" label-width="150px">
                            <el-input @blur="validateCnpj" v-model="form.cnpj" v-mask="'##.###.###/####-##'" style="width: auto;" :size="inputSize" :class="[isValid.cnpj ? '' : 'input-error']"></el-input>
                        </el-form-item>
                        <el-form-item label="Código CVM*" label-width="150px">
                            <el-input @blur="validateCodCvm" v-model="form.codCVM" style="width: auto;" :size="inputSize" :class="[isValid.codCVM ? '' : 'input-error']"></el-input>
                        </el-form-item>
                        <el-form-item label="Website RI*" label-width="150px">
                            <el-input @blur="validateIrWebsite" v-model="form.externalLinks.irWebsite" :class="[isValid.irWebsite ? '' : 'input-error']" style="width: auto;" :size="inputSize"></el-input>
                        </el-form-item>
                        <el-form-item label="OnePager" label-width="150px">
                            
                            <el-upload
                            class="upload-demo"
                            ref="upload"
                            action=""
                            :http-request="onHttpRequest"
                            :on-remove="onRemove"
                            drag
                            multiple
                            :file-list="fileList">
                                <i class="el-icon-upload"></i>
                                <!--<span>Arraste aqui ou clique para upload.</span>-->
                                <div class="upload-text">Arraste aqui ou clique para upload.</div>
                                <!--<i class="el-icon-upload2"></i>-->
                                <!--<el-button size="small" type="primary" @click="submitUpload">upload</el-button>-->
                            </el-upload>
                            
                            
                            <!--<el-input @blur="validateOnePager" v-model="form.externalLinks.onePager" style="width: auto;" :size="inputSize" :class="[isValid.onePager ? '' : 'input-error']"></el-input>-->
                        </el-form-item>
                    </div>
                </el-col>
            </el-row>
            <hr>
            <br>
            <div class="danger-container">
                <div class="danger">
                    <el-form-item label="DANGER ZONE" label-width="300px"></el-form-item>
                    <el-form-item label="Símbolo Performit*" label-width="180px">
                        <template slot="label">
                            <span>Símbolo Performit </span>
                            <el-tooltip effect="dark" content="Para consolidar mais de um ticker em uma mesma posição (ex: GOAU3 e GOAU4) separe os tickers por ','" placement="top-start">
                                <i class="el-icon-question"></i>
                            </el-tooltip>
                        </template>
                        <el-input @blur="validatePerformitSymbols" v-model="form.performit.symbols" style="width: auto;" :size="inputSize" :class="[isValid.performitSymbols ? '' : 'input-error']"></el-input>
                    </el-form-item>
                    <el-form-item label="Quantum Ação*" label-width="180px">
                        <el-input @blur="validateQuantumAcao" v-model="form.quantum.quantumNames.acao" style="width: auto;" :size="inputSize" :class="[isValid.quantumAcao ? '' : 'input-error']"></el-input>
                    </el-form-item>
                    <el-form-item label="Quantum Empresa*" label-width="180px">
                        <el-input @blur="validateQuantumEmpresa" v-model="form.quantum.quantumNames.empresa" style="width: auto;" :size="inputSize" :class="[isValid.quantumEmpresa ? '' : 'input-error']"></el-input>
                    </el-form-item>
                </div>
            </div>
        </el-form>
        <span slot="footer">
            <el-button @click="closeDialog">Cancelar</el-button>
            <el-button v-if="isNewCompany" type="primary" @click="addCompany">Adicionar Empresa</el-button>
            <el-button v-else type="primary" @click="updateCompany">Salvar Alterações</el-button>
        </span>
    </el-dialog>
</template>

<script>
/*eslint-disable*/
import fb from "@/services/firebaseConfig"
import firebase from "firebase/app"
import regex from "@/services/regex"
import {mask} from 'vue-the-mask'
import validators from "@/services/validators"

const db = fb.db

export default {
    data() {
        return {
            form: {
                myTicker: "",
                analyst: "",
                cnpj: "",
                codCVM: "",
                externalLinks: {
                    irWebsite: "",
                    onePager: "",
                    files: []
                },
                mySector: "",
                performit: {
                    symbols: []
                },
                quantum: {
                    quantumNames: {
                        acao: "",
                        empresa: ""
                    }
                },
                newCompany: Boolean,
                id: "",
                imgsrc: ""
            },
            inputSize: "medium",
            isValid: {
                myTicker: true,
                analyst: true,
                cnpj: true,
                codCVM: true,
                irWebsite: true,
                onePager: true,
                mySector: true,
                performitSymbols: true,
                quantumAcao: true,
                quantumEmpresa: true
            },
            fileList: [],
            onePagerFile: Object,
            file: Object,
        }
    },
    directives: {
        mask
    },
    props: {
        formCadastroVisible: Boolean,
        company: Object
    },
    methods: {
        closeDialog() {
            this.fileList = []
            this.$emit('closeDialog');
        },
        openDialog() {
            this.fillUpdateForm(this.company)
        },
        fillUpdateForm(company) {
            
            company.externalLinks.files.forEach(url => {
                let ref = firebase.storage().refFromURL(url)
                
                let nameArray = ref.name.split('_')
                let timestamp = nameArray.pop()
                let filename = nameArray.join('_')
                
                this.fileList.push({name: filename, url: url, storageFile: true})
            })
            
            console.log(this.fileList)
            
            this.form = company
        },
        async addCompany() {
            if(this.validateFormFields()) {
                await this.saveToStorage()
                let addCoveredCompany = firebase.functions().httpsCallable('addCoveredCompany')
                try {
                    this.form.performit.symbols = this.form.performit.symbols.split(',')
                    let addCoveredCompanyResult = await addCoveredCompany(this.form)
                    this.$root.$emit('showError', "Empresa adicionada com sucesso!", 'success')
                    this.closeDialog()
                } catch (err) {
                    this.$root.$emit('showError', err, 'error')
                    this.closeFullScreenLoading()
                }
            } else {
                this.closeFullScreenLoading()
            }
        },
        async updateCompany() {
            
            this.openFullScreenLoading()
            if(this.validateFormFields()) {
                await this.saveToStorage()
                console.log()
                let updateCoveredCompany = firebase.functions().httpsCallable('updateCoveredCompany')
                try {
                    if(!Array.isArray(this.form.performit.symbols)) this.form.performit.symbols = this.form.performit.symbols.split(',')
                    let updateCoveredCompanyResult = await updateCoveredCompany(this.form)
                    this.$root.$emit('showError', "Empresa alterada com sucesso", 'success')
                    this.closeDialog()
                    this.closeFullScreenLoading()
                } catch (err) {
                    this.$root.$emit('showError', err, 'error')
                    this.closeFullScreenLoading()
                }
            } else {
                this.closeFullScreenLoading()
            }
        },
        openFullScreenLoading() {
            this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(255, 255, 255, 0.7)'
            })
        },
        closeFullScreenLoading() {
            this.$loading().close()
        },
        validateFormFields() {
            this.validateMyTicker()
            this.validateAnalyst()
            this.validateCnpj()
            this.validateCodCvm()
            this.validateIrWebsite()
            this.validateOnePager()
            this.validateMySector()
            this.validatePerformitSymbols()
            this.validateQuantumAcao()
            this.validateQuantumEmpresa()
            
            return this.validForm()
        },
        validateMyTicker(){
            this.isValid.myTicker = !!this.form.myTicker
            return !!this.form.myTicker
        },
        validateAnalyst(){
            this.isValid.analyst = !!this.form.analyst
            return !!this.form.analyst
        },
        validateMySector(){
            this.isValid.mySector = !!this.form.mySector
            return !!this.form.mySector
        },
        validateCnpj(){
            this.isValid.cnpj = validators.validateCnpj(this.form.cnpj)
            return validators.validateCnpj(this.form.cnpj)
        },
        validateCodCvm(){
            this.isValid.codCVM = !!this.form.codCVM
            return !!this.form.codCVM
        },
        validateIrWebsite(){
            this.isValid.irWebsite = validators.validateUrl(this.form.externalLinks.irWebsite)
            return validators.validateUrl(this.form.externalLinks.irWebsite)
        },
        validateOnePager(){
            this.isValid.onePager = validators.validateUrl(this.form.externalLinks.onePager) || validators.isNullOrEmptyString(this.form.externalLinks.onePager)
            return validators.validateUrl(this.form.externalLinks.onePager) || validators.isNullOrEmptyString(this.form.externalLinks.onePager)
        },
        validatePerformitSymbols(){
            this.isValid.performitSymbols = this.form.performit.symbols.length > 0
            return this.form.performit.symbols.length > 0
        },
        validateQuantumAcao(){
            this.isValid.quantumAcao = !!this.form.quantum.quantumNames.acao
            return !!this.form.quantum.quantumNames.acao
        },
        validateQuantumEmpresa(){
            this.isValid.quantumEmpresa = !!this.form.quantum.quantumNames.empresa
            return !!this.form.quantum.quantumNames.acao
        },
        validForm() {
            return this.isValid.myTicker && this.isValid.analyst && this.isValid.cnpj && this.isValid.codCVM && this.isValid.irWebsite && this.isValid.onePager && this.isValid.mySector && this.isValid.performitSymbols && this.isValid.quantumAcao && this.isValid.quantumEmpresa
        },
        onHttpRequest(file, fileList) {
            console.log(file)
            this.fileList.push({fileData: file, name: file.file.name, storageFile: false})
            console.log(this.fileList)
            
        },
        onRemove(file, fileList) {
            this.fileList = fileList
        },
        async saveToStorage() {
            
            try {
                let utsPromiseList = []
                this.fileList.forEach(file => {
                    if(file.storageFile == false) {
                        let name = file.name.split('.')[0] + "_" + file.fileData.file.uid
                        let uploadTaskSnapshot = firebase.storage().ref().child(this.form.id + "/" + name).put(file.fileData.file)//.ref.getDownloadURL()
                        utsPromiseList.push(uploadTaskSnapshot);
                    }
                })
                
                let utsList = await Promise.all(utsPromiseList)
                
                let urlPromiseList = []
                
                utsList.forEach(uts => {
                    let urlPromise = uts.ref.getDownloadURL()
                    urlPromiseList.push(urlPromise)
                })
                
                let urlList = await Promise.all(urlPromiseList)
                
                let files = []
                this.fileList.forEach(file => {
                    if(file.storageFile == true) {
                        files.push(file.url)
                    }
                })
                files = files.concat(urlList)
                
                this.form.externalLinks.files = files
                
            } catch(err) {
                console.log(err)
            }
        }
    },
    computed: {
        formVisible: {
            get() {
                return this.formCadastroVisible
            },
            set(val) {
                this.formCadastroVisible = val
            }
        },
        isNewCompany() {
            return this.form.newCompany
        },
        getSrc() {
            return 'companies-logos/logo_' + this.form.myTicker.toLowerCase() + '.png';
        },
        
    }
}

</script>

<style scoped>
.el-dialog .main-title {
    font-size: 22px;
    color: #606266;
}

.input-error >>> input{
    border-color: red;
}
.teste {
    background-color: blue;
}
.header-container {
    text-align: center;
}
.danger {
    border-width: 1px;
    padding-top: 10px;
    padding-bottom: 12px;
    border-style: solid;
    width: 500px;
    border-color: red;
}
hr { 
    display: block;
    margin-top: 0.5em;
    margin-bottom: 0.5em;
    margin-left: auto;
    margin-right: auto;
    border-style: inset;
    border-width: 1px;
}
.logo-in-form {
  vertical-align: middle;
  max-height: 100%;
  max-width: 100%;
}
.el-image >>> img {
    max-height: 148px;
    max-width: 240px;
}
div >>> .el-upload-dragger {
    width: 204px;
    height: 80px;
}
.el-upload-dragger .el-icon-upload {
    margin: 0px;
    font-size: 35px;
}
.upload-text {
    position: relative;
    top: -15px;
    font-size: 12.5px;
}
.bigImage {
    height: 164px;
}
.danger-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.fields-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
}
</style>